import React, { Component } from 'react'

export default class HeaderDashboard extends Component {

    work = ()=>{
        alert('sadsa')
    }

    render() {
        const {filterQuotation} = this.props
        
        return (

            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                <div className="container-fluid">
                    <div className="header-body">
                        {/* Card stats */}
                        <div className="row">

                            <div className="col-xl-3 col-lg-6">
                                <div className="card card-stats mb-4 mb-xl-0">
                                    {/* <div className="card-body" onClick={()=>filterQuotation('c')}> */}
                                    <div className="card-body" onClick={()=>filterQuotation('c')}>
                                        <div className="row">
                                            <div className="col">
                                                {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                                                <span className="h2 font-weight-bold mb-0">On quotaion</span>
                                            </div>

                                        </div>
                                        <p className="mt-3 mb-0 text-muted text-sm">
                                            <span className="text-success mr-2"><i className="fa fa-fw fa-circle text-blue" /> 10 </span>
                                            <span className="text-nowrap">Quotations</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6">
                                <div className="card card-stats mb-4 mb-xl-0">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                                                <span className="h2 font-weight-bold mb-0">Pending</span>
                                            </div>

                                        </div>
                                        <p className="mt-3 mb-0 text-muted text-sm">
                                            <span className="text-danger mr-2"><i className="fa fa-fw fa-circle text-yellow" /> 152</span>
                                            <span className="text-nowrap">Quotations</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6">
                                <div className="card card-stats mb-4 mb-xl-0">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                                                <span className="h2 font-weight-bold mb-0">Scheduled</span>
                                            </div>

                                        </div>
                                        <p className="mt-3 mb-0 text-muted text-sm">
                                            <span className="text-warning mr-2"><i className="fa fa-fw fa-circle text-red" /> 152</span>
                                            <span className="text-nowrap">Quotations</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6">
                                <div className="card card-stats mb-4 mb-xl-0">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                                                <span className="h2 font-weight-bold mb-0">Completed</span>
                                            </div>
                                        </div>
                                        <p className="mt-3 mb-0 text-muted text-sm">
                                            <span className="text-success mr-2"><i className="fa fa-fw fa-circle text-green" /> 250</span>
                                            <span className="text-nowrap">Quotations</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
